var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.prizeList.length)?_c('div',{staticClass:"prizesComponent"},[_c('ul',{staticClass:"box"},_vm._l((_vm.prizeList),function(item){return _c('li',{key:item.activityPrizeId,on:{"click":_vm.goToPrizePage}},[_c('img',{attrs:{"src":item.prizePicture,"alt":""}})])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }